module.exports = __webpack_public_path__ + "img/IMG_1149_L_Black.b0cf52ec.jpg";